/* @generated */
// prettier-ignore
if (Intl.RelativeTimeFormat && typeof Intl.RelativeTimeFormat.__addLocaleData === 'function') {
  Intl.RelativeTimeFormat.__addLocaleData({
    "data": {
      "day": {
        "-1": "í gær",
        "-2": "í fyrradag",
        "0": "í dag",
        "1": "á morgun",
        "2": "eftir tvo daga",
        "future": {
          "one": "eftir {0} dag",
          "other": "eftir {0} daga"
        },
        "past": {
          "one": "fyrir {0} degi",
          "other": "fyrir {0} dögum"
        }
      },
      "day-narrow": {
        "-1": "í gær",
        "-2": "í fyrradag",
        "0": "í dag",
        "1": "á morgun",
        "2": "eftir tvo daga",
        "future": {
          "one": "eftir {0} dag",
          "other": "eftir {0} daga"
        },
        "past": {
          "one": "fyrir {0} degi",
          "other": "fyrir {0} dögum"
        }
      },
      "day-short": {
        "-1": "í gær",
        "-2": "í fyrradag",
        "0": "í dag",
        "1": "á morgun",
        "2": "eftir tvo daga",
        "future": {
          "one": "eftir {0} dag",
          "other": "eftir {0} daga"
        },
        "past": {
          "one": "fyrir {0} degi",
          "other": "fyrir {0} dögum"
        }
      },
      "hour": {
        "0": "þessa stundina",
        "future": {
          "one": "eftir {0} klukkustund",
          "other": "eftir {0} klukkustundir"
        },
        "past": {
          "one": "fyrir {0} klukkustund",
          "other": "fyrir {0} klukkustundum"
        }
      },
      "hour-narrow": {
        "0": "þessa stundina",
        "future": {
          "one": "+{0} klst.",
          "other": "+{0} klst."
        },
        "past": {
          "one": "-{0} klst.",
          "other": "-{0} klst."
        }
      },
      "hour-short": {
        "0": "þessa stundina",
        "future": {
          "one": "eftir {0} klst.",
          "other": "eftir {0} klst."
        },
        "past": {
          "one": "fyrir {0} klst.",
          "other": "fyrir {0} klst."
        }
      },
      "minute": {
        "0": "á þessari mínútu",
        "future": {
          "one": "eftir {0} mínútu",
          "other": "eftir {0} mínútur"
        },
        "past": {
          "one": "fyrir {0} mínútu",
          "other": "fyrir {0} mínútum"
        }
      },
      "minute-narrow": {
        "0": "á þessari mínútu",
        "future": {
          "one": "+{0} mín.",
          "other": "+{0} mín."
        },
        "past": {
          "one": "-{0} mín.",
          "other": "-{0} mín."
        }
      },
      "minute-short": {
        "0": "á þessari mínútu",
        "future": {
          "one": "eftir {0} mín.",
          "other": "eftir {0} mín."
        },
        "past": {
          "one": "fyrir {0} mín.",
          "other": "fyrir {0} mín."
        }
      },
      "month": {
        "-1": "í síðasta mánuði",
        "0": "í þessum mánuði",
        "1": "í næsta mánuði",
        "future": {
          "one": "eftir {0} mánuð",
          "other": "eftir {0} mánuði"
        },
        "past": {
          "one": "fyrir {0} mánuði",
          "other": "fyrir {0} mánuðum"
        }
      },
      "month-narrow": {
        "-1": "í síðasta mán.",
        "0": "í þessum mán.",
        "1": "í næsta mán.",
        "future": {
          "one": "eftir {0} mán.",
          "other": "eftir {0} mán."
        },
        "past": {
          "one": "fyrir {0} mán.",
          "other": "fyrir {0} mán."
        }
      },
      "month-short": {
        "-1": "í síðasta mán.",
        "0": "í þessum mán.",
        "1": "í næsta mán.",
        "future": {
          "one": "eftir {0} mán.",
          "other": "eftir {0} mán."
        },
        "past": {
          "one": "fyrir {0} mán.",
          "other": "fyrir {0} mán."
        }
      },
      "nu": ["latn"],
      "quarter": {
        "-1": "síðasti ársfjórðungur",
        "0": "þessi ársfjórðungur",
        "1": "næsti ársfjórðungur",
        "future": {
          "one": "eftir {0} ársfjórðung",
          "other": "eftir {0} ársfjórðunga"
        },
        "past": {
          "one": "fyrir {0} ársfjórðungi",
          "other": "fyrir {0} ársfjórðungum"
        }
      },
      "quarter-narrow": {
        "-1": "síðasti ársfj.",
        "0": "þessi ársfj.",
        "1": "næsti ársfj.",
        "future": {
          "one": "eftir {0} ársfj.",
          "other": "eftir {0} ársfj."
        },
        "past": {
          "one": "fyrir {0} ársfj.",
          "other": "fyrir {0} ársfj."
        }
      },
      "quarter-short": {
        "-1": "síðasti ársfj.",
        "0": "þessi ársfj.",
        "1": "næsti ársfj.",
        "future": {
          "one": "eftir {0} ársfj.",
          "other": "eftir {0} ársfj."
        },
        "past": {
          "one": "fyrir {0} ársfj.",
          "other": "fyrir {0} ársfj."
        }
      },
      "second": {
        "0": "núna",
        "future": {
          "one": "eftir {0} sekúndu",
          "other": "eftir {0} sekúndur"
        },
        "past": {
          "one": "fyrir {0} sekúndu",
          "other": "fyrir {0} sekúndum"
        }
      },
      "second-narrow": {
        "0": "núna",
        "future": {
          "one": "+{0} sek.",
          "other": "+{0} sek."
        },
        "past": {
          "one": "-{0} sek.",
          "other": "-{0} sek."
        }
      },
      "second-short": {
        "0": "núna",
        "future": {
          "one": "eftir {0} sek.",
          "other": "eftir {0} sek."
        },
        "past": {
          "one": "fyrir {0} sek.",
          "other": "fyrir {0} sek."
        }
      },
      "week": {
        "-1": "í síðustu viku",
        "0": "í þessari viku",
        "1": "í næstu viku",
        "future": {
          "one": "eftir {0} viku",
          "other": "eftir {0} vikur"
        },
        "past": {
          "one": "fyrir {0} viku",
          "other": "fyrir {0} vikum"
        }
      },
      "week-narrow": {
        "-1": "í síðustu viku",
        "0": "í þessari viku",
        "1": "í næstu viku",
        "future": {
          "one": "eftir {0} viku",
          "other": "eftir {0} vikur"
        },
        "past": {
          "one": "fyrir {0} viku",
          "other": "fyrir {0} vikum"
        }
      },
      "week-short": {
        "-1": "í síðustu viku",
        "0": "í þessari viku",
        "1": "í næstu viku",
        "future": {
          "one": "eftir {0} viku",
          "other": "eftir {0} vikur"
        },
        "past": {
          "one": "fyrir {0} viku",
          "other": "fyrir {0} vikum"
        }
      },
      "year": {
        "-1": "á síðasta ári",
        "0": "á þessu ári",
        "1": "á næsta ári",
        "future": {
          "one": "eftir {0} ár",
          "other": "eftir {0} ár"
        },
        "past": {
          "one": "fyrir {0} ári",
          "other": "fyrir {0} árum"
        }
      },
      "year-narrow": {
        "-1": "á síðasta ári",
        "0": "á þessu ári",
        "1": "á næsta ári",
        "future": {
          "one": "eftir {0} ár",
          "other": "eftir {0} ár"
        },
        "past": {
          "one": "fyrir {0} árum",
          "other": "fyrir {0} árum"
        }
      },
      "year-short": {
        "-1": "á síðasta ári",
        "0": "á þessu ári",
        "1": "á næsta ári",
        "future": {
          "one": "eftir {0} ár",
          "other": "eftir {0} ár"
        },
        "past": {
          "one": "fyrir {0} ári",
          "other": "fyrir {0} árum"
        }
      }
    },
    "locale": "is"
  });
}